import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	illustrationLabelSpork: {
		id: 'project-create-importer-upload-flow.project-create-screen.illustration.jwm.illustration-label-spork',
		defaultMessage:
			'A Jira project in list view. It displays the name of the project that is typed in.',
		description: 'Accessible label for the illustration in create project screen',
	},
});
